<template>
  <CompanyDetails>
    <template v-slot:default="{ company }">
      <DocumentTitle activeClass="mb-3">서비스 제공자 정보</DocumentTitle>
      <table class="creditor__table">
        <tr>
          <td>상호</td>
          <td>
            <span class="seal-box">
              {{ company.name }}
              <img src="@/assets/images/documents/funda_onto_seal.png" />
            </span>
          </td>
        </tr>
        <tr>
          <td>온투업등록번호</td>
          <td v-html="company.lendingRegisterNumber"></td>
        </tr>
        <tr>
          <td>전화번호</td>
          <td>{{ company.phoneNumber }}</td>
        </tr>
        <tr>
          <td>사업자등록번호</td>
          <td>{{ company.businessNumber }}</td>
        </tr>
        <tr>
          <td>주소</td>
          <td v-html="company.address"></td>
        </tr>
      </table>
    </template>
  </CompanyDetails>
</template>

<script>
import DocumentTitle from '@/components/documents/DocumentTitle.vue'
import CompanyDetails from '@/components/company/CompanyDetails.vue'

export default {
  components: {
    DocumentTitle,
    CompanyDetails,
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common/_variables.scss';

.creditor {
  &__table {
    width: 100%;
    border-top: solid 1px #727d8c;
    border-collapse: collapse;

    tr {
      border-bottom: solid 1px #d7e1ea;
      td {
        height: 48px;
      }
      td:first-child {
        width: calc(136% / 325 * 100);
        background-color: #f4faff;
        font-weight: 600 !important;
        font-size: 15px !important;
        line-height: 2.13;
        text-align: center;
        color: $black;

        @media screen and (max-width: 350px) {
          font-size: 13px;
        }
      }
      td:last-child,
      td:last-child * {
        font-weight: 900 !important;
        font-size: 16px !important;
        line-height: 2;
        text-align: center;
        color: $black;

        @media screen and (max-width: 350px) {
          font-size: 14px;
        }
      }
    }
  }
}

.seal-box {
  position: relative;

  img {
    width: 80px;
    position: absolute;
    top: -32px;
    left: 40px;
  }
}
</style>
